import { FC } from 'react';

import { Reactions } from '../../reactions';

export const DetectorEmotionClient: FC<{
  sendEmotionsSelect?: (result: { category: string[]; emo: string[] }) => void;
}> = ({ sendEmotionsSelect }) => {
  return (
    <div className="min-w-[250px] w-full md:w-[30vw] lg:w-[15vw] h-full">
      <Reactions sendEmotionsSelect={sendEmotionsSelect} />
    </div>
  );
};
